import { Component, signal, inject, OnInit, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoadingComponent } from './core/components/global-loading.component';
import { UploadProgressBadgeComponent } from './shared/components/upload-progress-badge/upload-progress-badge.component';
import { SignalRService } from './services/signalr.service';
import { NotificationService } from './services/notification.service';
import { AuthService } from './core/services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Toast } from 'primeng/toast';
import { UnsavedChangesDialogComponent } from './shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoadingComponent, UploadProgressBadgeComponent, Toast, UnsavedChangesDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('Kansei_UI');

  private signalRService = inject(SignalRService);
  private notificationService = inject(NotificationService);
  private authService = inject(AuthService);
  private hasInitialized = false;

  constructor() {
    // Subscribe to SignalR notifications
    this.signalRService.notification$
      .pipe(takeUntilDestroyed())
      .subscribe(notification => {
        if (notification) {
          // Display using existing NotificationService
          this.notificationService.show({
            type: notification.type,
            title: notification.title,
            message: notification.message
          });
        }
      });

    // Watch for authentication state changes and manage SignalR connection
    // Only after initial load to avoid stopping connection during SSO initialization
    effect(() => {
      const isAuth = this.authService.isAuthenticated();

      // Skip until ngOnInit completes to avoid premature connection management
      if (!this.hasInitialized) {
        return;
      }

      if (isAuth) {
        this.signalRService.startConnection();
      } else {
        this.signalRService.stopConnection();
      }
    });
  }

  ngOnInit() {
    // Check authentication state
    const isAuth = this.authService.isAuthenticated();

    // Mark as initialized so effect can now manage connection changes
    this.hasInitialized = true;

    if (isAuth) {
      this.signalRService.startConnection();
    }
  }
}
